import React from 'react';
import Navbar from './Navbar/navbar';
import Footer from './Footer/footer';
import Loader from './Loader/loader';
import FetchLocationLoader from './Loader/fetchLocationLoader';
import {connect} from 'react-redux';


 class Main extends React.Component{

   constructor(props) {
     super(props);
   }

  componentDidMount() {

  }


  render () {


    return (
      <div className="container">

        <Navbar />


        <Loader/>
        <FetchLocationLoader />

        {this.props.children}
        <Footer />
      </div>

    );
  }

}


function mapStateToProps(state) {
  return {
    loader: state.Loader,
    filterData: state.SportsFilter,
    viewport: state.ViewPort
  };
}

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main.js